import Container from "../../components/container/container";
import MultiStepForm from "./multistep-form/multistep-form";
import ContainerTitle from "../../components/container-title/container-title";
import { FormContainerStyled } from "./book-appointments.styles";
import { useContext, useState } from "react";
import { StepperContext, StepperDataContext } from "./context/stepper-context";
import { useNavigate } from "react-router-dom";
import { DialogsProvider, useDialogs } from "@toolpad/core";
import { Client } from "./multistep-form/initial-details/types";
import { SelectedPets } from "./multistep-form/pet-details/types";
import { TimeSlot } from "./multistep-form/book-slot/manually-schedule-modal/types";
import { FormProvider, useForm } from "react-hook-form";
import { InitialPetDetailsSchema } from "../../utils/validations";
import { yupResolver } from "@hookform/resolvers/yup";

const FormContainer: React.FC = () => {
  return (
    <FormContainerStyled>
      <MultiStepForm />
    </FormContainerStyled>
  );
};

const Content: React.FC = () => {
  const navigate = useNavigate();
  const dialogs = useDialogs();
  const { activeStep, setActiveStep } = useContext(StepperContext);

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(InitialPetDetailsSchema),
  });

  const handleBackButton = async () => {
    if (activeStep > 0) setActiveStep(activeStep - 1);
    else {
      const confirmed = await dialogs.confirm(
        "Are you sure you want to perform this action, you will lose your data?",
        {
          okText: "Yes",
          cancelText: "No",
        }
      );
      if (confirmed) navigate("/dashboard");
    }
  };

  return (
    <Container>
      <ContainerTitle
        showButton={false}
        showBackButton={true}
        backButtonAction={handleBackButton}
        title="Book appointment"
      />
      <FormProvider {...methods}>
        <FormContainer />
      </FormProvider>
    </Container>
  );
};

const BookAppointments: React.FC = () => {
  const [activeStep, setActiveStep] = useState<number>(0);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [selectedPatients, setSelectedPatients] = useState<SelectedPets>([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<TimeSlot | null>(
    null
  );
  const [selectedProvider, setSelectedProvider] = useState<any | null>(null);
  const [isRescheduleEnabled, setIsRescheduleEnabled] = useState(false);
  return (
    <StepperContext.Provider value={{ activeStep, setActiveStep }}>
      <StepperDataContext.Provider
        value={{
          selectedClient,
          setSelectedClient,
          selectedPatients,
          setSelectedPatients,
          selectedTimeSlot,
          setSelectedTimeSlot,
          selectedProvider,
          setSelectedProvider,
          isRescheduleEnabled,
          setIsRescheduleEnabled,
        }}
      >
        <DialogsProvider>
          <Content />
        </DialogsProvider>
      </StepperDataContext.Provider>
    </StepperContext.Provider>
  );
};

export default BookAppointments;
